import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './DesktopHeader.css';
import './Header.css';

// 針對 eslint 的 no-unused-vars 警告，menuBarRef 未被使用，這裡直接移除
function DesktopHeader({
  seriesDropdownOpen,
  characterDropdownOpen,
  systemActivityDropdownOpen,
  toggleSeriesDropdown,
  toggleCharacterDropdown,
  toggleSystemActivityDropdown,
  seriesOptions,
  characterOptions,
  systemActivityOptions,
  convertToPinyin,
  seriesDropdownRef,
  characterDropdownRef,
  systemActivityDropdownRef,
  setSystemActivityDropdownOpen,
  setSeriesDropdownOpen,
  setCharacterDropdownOpen
}) {
  const headerRef = useRef(null);

  // 原本 menuBarHeight 狀態未被使用，這裡直接移除 useState 及相關邏輯
  useEffect(() => {
    function updateHeight() {
      // 若未來有需要可在此處擴充
    }
    updateHeight();
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  useEffect(() => {
    function setDesktopHeaderHeight() {
      const titleHeader = document.querySelector('.title-header.fixed-header');
      const headerCenter = document.querySelector('.header-center.fixed-header');
      if (titleHeader && headerCenter) {
        const totalHeight = titleHeader.offsetHeight + headerCenter.offsetHeight - 1;
        document.documentElement.style.setProperty('--desktop-header-height', totalHeight + 'px');
      }
    }
    setDesktopHeaderHeight();
    window.addEventListener('resize', setDesktopHeaderHeight);
    return () => window.removeEventListener('resize', setDesktopHeaderHeight);
  }, []);

  // 處理下拉選單點擊事件
  const handleDropdownClick = (setDropdownOpen) => {
    if (typeof setDropdownOpen === 'function') {
      setDropdownOpen(false);
    }
  };

  return (
    <div className="App desktop">
      {/* 佔位用的 header-fixed-wrapper */}
      {/* 固定顯示的 header */}
      <div className="title-header fixed-header" ref={headerRef}>
        <Link to="/" className="title-link mobile-logo-center">
          <img src="/title.webp" alt="ちいかわ開心代購" className="title-logo" />
        </Link>
      </div>
      <div className="header-center fixed-header">
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid container-fluid-padding">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link to="/order" className="nav-link me-3 hide-order-query">訂單查詢</Link>
              </li>
              <li className="nav-item">
                <Link to="/stock?page=1" className="nav-link me-3">品項瀏覽</Link>
              </li>
              <li className="nav-item dropdown nav-item-margin" ref={systemActivityDropdownRef}>
                <button
                  className="nav-link dropdown-toggle"
                  id="systemActivityDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded={systemActivityDropdownOpen}
                  onClick={toggleSystemActivityDropdown}
                >
                  專題/活動
                </button>
                <ul
                  className={`dropdown-menu dropdown-menu-center ${systemActivityDropdownOpen ? 'show' : ''}`}
                  aria-labelledby="systemActivityDropdown"
                  onMouseLeave={() => handleDropdownClick(setSystemActivityDropdownOpen)}
                >
                  {systemActivityOptions.map((option, index) => (
                    <li key={index}>
                      <Link
                        to={`/activity/${encodeURIComponent(option)}`}
                        className="dropdown-item"
                        onClick={() => handleDropdownClick(setSystemActivityDropdownOpen)}
                      >
                        {option}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="nav-item dropdown nav-item-margin" ref={seriesDropdownRef}>
                <button
                  className="nav-link dropdown-toggle"
                  id="seriesDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded={seriesDropdownOpen}
                  onClick={toggleSeriesDropdown}
                >
                  系列查詢
                </button>
                <ul
                  className={`dropdown-menu dropdown-menu-center ${seriesDropdownOpen ? 'show' : ''}`}
                  aria-labelledby="seriesDropdown"
                  onMouseLeave={() => handleDropdownClick(setSeriesDropdownOpen)}
                >
                  {seriesOptions.map((option, index) => (
                    <li key={index}>
                      <Link
                        to={`/series/${convertToPinyin(option)}`}
                        className="dropdown-item"
                        onClick={() => handleDropdownClick(setSeriesDropdownOpen)}
                      >
                        {option}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="nav-item dropdown nav-item-margin" ref={characterDropdownRef}>
                <button
                  className="nav-link dropdown-toggle"
                  id="characterDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded={characterDropdownOpen}
                  onClick={toggleCharacterDropdown}
                >
                  角色查詢
                </button>
                <ul
                  className={`dropdown-menu dropdown-menu-center ${characterDropdownOpen ? 'show' : ''}`}
                  aria-labelledby="characterDropdown"
                  onMouseLeave={() => handleDropdownClick(setCharacterDropdownOpen)}
                >
                  {Object.entries(characterOptions).map(([key, value]) => (
                    <li key={value}>
                      <Link
                        to={`/products_character/${value}`}
                        className="dropdown-item"
                        onClick={() => handleDropdownClick(setCharacterDropdownOpen)}
                      >
                        {key}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
              
            </ul>
          </div>
        </nav>
        <Link to="/cart" className="cart-navbar-icon" aria-label="前往購物車">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 21s-5.05-4.35-7.07-6.36C2.07 12.14 2 9.28 4.11 7.21c2.11-2.07 5.53-1.7 7.39.62 1.86-2.32 5.28-2.69 7.39-.62 2.11 2.07 2.04 4.93-.82 7.43C17.05 16.65 12 21 12 21z"
              fill="#ff9800"
              stroke="#ff9800"
              strokeWidth="1"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default DesktopHeader; 